import axios from "axios";
import { useState } from "react";
import LS_CONSTANTS from "../constants/LSConstants";

const useNetworkRequest = () => {
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async ({
    url,
    method = "GET",
    body = null,
    authRequired = false,
    customHeaders = {},
    responseType = "json",
    timeout = 60000, //60 Sec default timeout
    signal = null,
  }) => {
    try {
      const timestamp = Date.now().toString();
      setLoading(true);

      const headers = {
        "X-Application-Name": "wheelz-radar",
      };

      if (authRequired) {
        const userData = JSON.parse(
          localStorage.getItem(LS_CONSTANTS.LS_USER_DATA)
        );
        headers.Authorization = "Bearer " + userData.access_token;
      }

      Object.assign(headers, customHeaders);

      const response = await axios({
        method,
        url: url,
        baseURL: "/",
        data: body,
        params: { when: timestamp },
        headers,
        responseType,
        timeout,
        signal,
      });
      setResult(response.data);
      // console.log("Network Request", response);
      const resp = {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
      return resp; // Return the data directly
    } catch (error) {
      // console.error("Error fetching data:", error);
      setError("Error fetching data");
      throw error; // Rethrow the error so that it can be caught by the caller
    } finally {
      setLoading(false);
    }
  };

  return { result, error, loading, fetchData };
};

export default useNetworkRequest;
